import { mutator } from 'satcheljs';
import getStore from '../store/store';
import setIsPerformingServiceUpdate from '../actions/setIsPerformingServiceUpdate';

/**
 * Updates the current services getting status in the store.
 */
export default mutator(setIsPerformingServiceUpdate, actionMessage => {
    let store = getStore();
    store.isPerformingServiceUpdate = actionMessage.isPerformingServiceUpdate;
});
